import { Item } from '../../../types/interfaces';
import { findPriceForQuantity } from './findPriceForQuantity';

export function calculateCartPrices(items: Item[], APO: number = 0): Item[] {
  const maxQuantity = items.reduce((total, item) => {
    return item.do_not_count ? total : total + item.quantity;
  }, APO);

  return items.map((item) => {
    const pricePerUnit = findPriceForQuantity(item.prices, maxQuantity);

    const verificationPricePerUnit = item.verification_item
      ? findPriceForQuantity(item.verification_item.prices, item.verification_quantity)
      : 0;

    const passportPricePerUnit = item.passport_item
      ? findPriceForQuantity(item.passport_item.prices, item.passport_quantity)
      : 0;

    return {
      ...item,
      price: pricePerUnit,
      totalPrice:
        pricePerUnit * item.quantity +
        verificationPricePerUnit * item.verification_quantity +
        passportPricePerUnit * item.passport_quantity,
      verificationPrice: verificationPricePerUnit,
      verificationTotalPrice: verificationPricePerUnit * item.verification_quantity,
      passportPrice: passportPricePerUnit,
      passportTotalPrice: passportPricePerUnit * item.passport_quantity,
    };
  });
}
